import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { routes as clustersRoutes } from '../cluster-management/clusters.routes';
import { routes as connectionsRoutes } from '../connections/connections.routes';
import { routes as dataSourcesRoutes } from '../data-management/data-sources.routes';
import { routes as themeRoutes } from '../theme-management/theme-management.routes';

export const routes: Routes = [
	{
		path: '',
		data: { breadcrumb: 'BREADCRUMBS.CONFIG' },
		children: [
			{
				path: '',
				pathMatch: 'full',
				redirectTo: 'data-sources'
			},
			{
				path: 'data-sources',
				children: dataSourcesRoutes
			},
			{
				path: 'cluster-management',
				children: clustersRoutes
			},
			{
				path: 'connections',
				children: connectionsRoutes
			},
			{
				path: 'theme-management',
				data: { breadcrumb: 'BREADCRUMBS.THEMES' },
				children: themeRoutes
			},
			{
				path: 'document-manager',
				data: { breadcrumb: 'DOCUMENT_MANAGER_CONNECTIONS.TITLES.BREADCRUMB' },
				loadChildren: () =>
					import('../document-manager/document-manager.routes').then(
						(module) => module.routes
					)
			}
		]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class ConfigRoutingModule {}
